import { Outlet } from 'react-router';
import { t } from '@/i18n';
import { ConnectionBadge } from './components/ConnectionBadge';
import { Toasts } from './components/Toasts';

/** Root layout: connection badge + toasts around the current page. */
export function Shell() {
  return (
    <>
      <ConnectionBadge />
      <Outlet />
      <Toasts />
    </>
  );
}

/** Placeholder while a route chunk loads. */
export function RouteLoading() {
  return (
    <div className="p-10 text-center font-extrabold" role="status">
      {t('common.loading')}
    </div>
  );
}
